import "./Plugins/jquery";
import "./Plugins/bootstrap-table";
import "./Plugins/grid";
import "./Plugins/jquery-smartresize";
import "./Plugins/setu-scroll";
import "./Plugins/treenav";
import "./ci/forms";
import "./ci/accordions";
import "./ci/collapse";
import "./ci/lightbox-config";
import "./ci/share-popover";
import "./ci/navigation";
import "./ci/checkout";
import "../sass/screen.scss";
import "../Images/logo_lapp.svg";
import "../Images/blank.gif";
import "../Images/ajax-loader.gif";
import "../Images/youtube-play.svg";
import "../Images/youtube-playable-indicator.png";
import "../Images/apple-touch-icon.png";
import "../Images/hki-favicon.png";
import "../Images/logo_fleximark.png";
import "../Images/logo_fleximark.svg";
import "../Icons/BackendLayouts/lapp_1_columns.svg";
import "../Icons/BackendLayouts/lapp_2_columns.svg";
import "../Icons/BackendLayouts/lapp_startpage.svg";
import "../Icons/BackendLayouts/lapp_2_columns_50_50.svg";
import "../Icons/tx_dgp_inlinecontent.svg";
import "../Icons/tx_dgp_inlinelinks.svg";

import { utilities } from "./ci/utilities";
import { eventsResponsive } from "./ci/events-responsive";
import { plugins } from "./ci/plugins";
import { modalRemote } from "./ci/modalremote";
import { Popover } from "bootstrap";

(() => {
    window.onerror = function (message, url, line_number) {
        if (window.console && console.error) {
            console.error('Uncaught error in: ' + url + ':' + line_number + '\nDetails: ' + message);
        }
    };

    utilities.init();
    eventsResponsive.init();
    plugins.init();
    modalRemote.init();

    if (!window.HTMLPictureElement || !('sizes' in document.createElement('img'))) {
        document.createElement('picture');
    }

    if ('ontouchstart' in document.documentElement) {
        $('html').addClass('mobile');
    }

    // used for performance lazySize loading
    window.lazySizesConfig = window.lazySizesConfig || {};
    window.lazySizesConfig.loadMode = 1;
    import('lazysizes');

    utilities.equalHeightRowFix('.js-calc-height-row', 'js-calc-height');

    $('[data-equal]').each(function () {
        const $this = $(this),
            target = $this.data('setu-equal');
        utilities.equalHeight($this, target);
    });

    $('body').on('click', function (e) {
        $('[data-bs-toggle="popover"]').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                Popover.getOrCreateInstance(this).hide();
            }
        });
    });

    $(document).on('mouseover click', ('.advancedtooltip'), function (e) {
        const popoverContent = $('.' + $(e.target).data('setu-contentclass')).html();
        Popover.getOrCreateInstance(e.target, {
            animation: true,
            container: $(e.target).data('setu-attach') || $(e.target).parent(),
            content: popoverContent,
            html: true,
            placement: 'bottom',
            trigger: 'manual',
            sanitize: false,
        }).toggle();
    });

    $(document).on('mouseout click', ('.advancedtooltip'), function (e) {
        Popover.getOrCreateInstance(e.target).toggle();
    });
})();

export { events as Events } from "./ci/events";
export { glossary } from "./ci/glossary";
export { eventsResponsive as EventsResponsive }
export * as Sweetalert2 from "sweetalert2";
export * as Sweetalert from "sweetalert";
export { AdvancedTooltip } from "./ci/advancedtooltip";
export { checkout as Checkout } from "./ci/checkout";
export { plugins as Plugins };
export * as bootstrap from "bootstrap";
export { default as i18next } from 'i18next';
export { default as resourcesToBackend } from 'i18next-resources-to-backend';
